module.exports = __webpack_public_path__ + "static/img/yinjinrencai.17cc4eb0.png";